import {createDomain} from 'effector';

export const AppDomain = createDomain();
